import React from 'react';
import { shape, string, arrayOf } from 'prop-types';

import { StructuredData } from '..';

const DEFAULT_LINK = {
    name: 'Gumtree',
    url: 'https://www.gumtree.com/uk',
};

const getSchema = (links = []) => {
    let linksSchema = links;
    if (linksSchema.length === 0) linksSchema = [DEFAULT_LINK];
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: linksSchema.map((link, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@id': link.url,
                name: link.name,
            },
        })),
    };
};

const BreadcrumbsSchema = ({ links }) => <StructuredData data={getSchema(links)} />;

BreadcrumbsSchema.propTypes = {
    links: arrayOf(
        shape({
            name: string.isRequired,
            url: string,
        })
    ).isRequired,
};

export { getSchema };

export default BreadcrumbsSchema;
